import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { _className, LL_H_C, LL_V_L, openContent } from '@nu-art/thunderstorm-frontend/index';
import { filterInstances } from '@nu-art/ts-common';
import './Tooltip_References.scss';
import React from 'react';
export class Tooltip_References extends React.Component {
    resolveSnomedLink = (snomedId) => {
        const baseUrl = 'https://snomedbrowser.com/Codes/Details/';
        return baseUrl + snomedId;
    };
    renderSnomedLink = (ref) => {
        return _jsx("a", { href: this.resolveSnomedLink(ref.data.id), target: '_blank', className: 'ref-link snomed', children: ref.data.id });
    };
    render() {
        const refs = this.props.refs;
        if (!filterInstances(refs).length)
            return '';
        const failedIndexAlert = () => {
            return _jsxs(LL_H_C, { className: 'ref-warning', children: [_jsx("span", { className: 'warning-icon', children: "!" }), _jsx("div", { className: 'warning-message', children: "Failed to index this ID" }), _jsx("span", { className: 'warning-icon', children: "!" })] });
        };
        const tooltipContent = () => (_jsx(LL_V_L, { className: 'refs-tooltip__content', children: refs.map(ref => {
                const type = ref?.type;
                if (type !== 'snomed' && type !== 'loinc')
                    return '';
                switch (type) {
                    case 'snomed': {
                        const _ref = ref;
                        return _jsxs(React.Fragment, { children: [ref.creationStatus === 'failed' && failedIndexAlert(), _jsxs(LL_H_C, { className: 'ref-id', children: [_jsx("div", { children: _jsx("b", { children: "Snomed ID:" }) }), this.renderSnomedLink(_ref)] }), _ref.data.names?.[0]?.length && _jsxs(LL_H_C, { style: { alignItems: 'flex-start' }, className: 'ref-name', children: [_jsx("div", { children: _jsx("b", { children: "Snomed Name:" }) }), _jsx("div", { children: `${_ref.data.names?.[0]}` })] })] }, _ref._id);
                    }
                    case 'loinc': {
                        const _ref = ref;
                        return _jsx(React.Fragment, { children: _jsxs(LL_H_C, { className: 'ref-id', children: [_jsx("div", { children: _jsx("b", { children: "Loinc ID:" }) }), _jsx("div", { children: _ref.data.id })] }) }, _ref._id);
                    }
                }
                return _jsxs(_Fragment, { children: [_jsxs(LL_H_C, { className: 'ref-id', children: [_jsx("div", { children: _jsx("b", { children: `${type === 'snomed' ? 'Snomed' : 'Loinc'} ID:` }) }), _jsx("div", { children: ref.data.id })] }), _jsxs(LL_H_C, { style: { alignItems: 'flex-start' }, className: 'ref-name', children: [_jsx("div", { children: _jsx("b", { children: "Snomed Name:" }) }), _jsx("div", { children: ref.data.names?.[0].length && `${ref.data.names?.[0]}` })] })] });
            }) }));
        const tooltip = openContent.tooltip.right('ref-tool-tip', tooltipContent, { contentHoverDelay: 500 });
        return _jsx("div", { className: _className('refs-tooltip', refs.some(ref => ref.creationStatus === 'failed') ? 'error' : ''), ...tooltip, children: "R" });
    }
}
//# sourceMappingURL=Tooltip_References.js.map